import { useConfigurationOptionsContext } from "app/providers/DoorOptionsProvider";
import MeasurementOptionControls from "features/option-controls/measurements-option-controls";
import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import FormGroup from "shared/ui/FormGroup";
import Input from "shared/ui/input";
import Label from "shared/ui/label";

const TaatsdeurSelfInstallment = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const {
    updateSelfAssembleData,
    updateSearchParam,
    selfAssembleDoorData,
    eigenwijs,
  } = useConfigurationOptionsContext();

  const [isDefaultDataInitialized, setIsDefaultDataInitialized] =
    useState(false);

  const doorMeasurements = useMemo(() => {
    if (eigenwijs)
      return {
        width: eigenwijs.sizeObjects[0].customWidth,
        height: eigenwijs.sizeObjects[0].customHeight,
      };
    return { width: 0, height: 0 };
  }, [eigenwijs?.sizeObjects]);

  useEffect(() => initializeDefaultTaatsdeurSelfInstallmentData(), []);
  useEffect(() => {
    if (!isDefaultDataInitialized) return;
    setDoorMeasurements(doorMeasurements);
  }, [isDefaultDataInitialized, doorMeasurements]);

  const initializeDefaultTaatsdeurSelfInstallmentData = () => {
    const data = { ...selfAssembleDoorData };
    data.measurements = {
      rotation: "left", //Default
      easyToReach: false, //Default
      deliverInParts: false, //Default
      onLocation: false, //Default
      extraFloor: true, //Default
      typePlafond: "beton", //Default
      view: "zelfmontage", //Default
      leftStelprofiel: false, //Default
      rightStelprofiel: false, //Default
      hasFloorHeating: false, //Default
      smokeAlarm: false, //Default
      pipe: false, //Default
    };

    if (searchParams.get("label")) data.label = searchParams.get("label") || "";

    updateSelfAssembleData(data);
    setIsDefaultDataInitialized(true);
  };

  const setDoorMeasurements = (doorMeasurements: {
    width: number;
    height: number;
  }) => {
    const data = { ...selfAssembleDoorData };
    data.measurements.sponningsBreedte = doorMeasurements.width;
    data.measurements.sponningsHoogte = doorMeasurements.height;
    data.measurements.skews = {
      width: Array(4)
        .fill(0)
        .map(() => ({
          size: doorMeasurements.width,
          offset: 0,
        })),
      height: Array(3)
        .fill(0)
        .map(() => ({
          size: doorMeasurements.height,
          offset: 0,
        })),
      openHeight: [
        Array(4)
          .fill(0)
          .map(() => ({
            size: doorMeasurements.height,
            offset: 0,
          })),
      ],
    };
    updateSelfAssembleData(data);
  };

  const setLabel = (label: string) => {
    updateSelfAssembleData({
      ...selfAssembleDoorData,
      label,
    });
    updateSearchParam("label", label);
  };

  return (
    <div className="gg-flex gg-flex-col gg-gap-y-5">
      <FormGroup>
        <Label
          htmlFor="self-installment-label"
          className="gg-font-bold gg-mb-2"
        >
          Label
        </Label>
        <Input
          placeholder={
            "Vul hier de ruimte in waar de deur komt, bijv. Woonkamer."
          }
          key={`self-installment-label`}
          className={
            "gg-pr-12 gg-py-3 gg-border-dark-blue-200 placeholder:gg-text-grey-200 placeholder:gg-italic"
          }
          id={`self-installment-label`}
          data-testid={"self-installment-label"}
          type={"string"}
          value={selfAssembleDoorData.label}
          onChange={(e) => setLabel(e.target.value)}
          aria-label="Label"
        />
      </FormGroup>

      <MeasurementOptionControls />
    </div>
  );
};
export default TaatsdeurSelfInstallment;
